module.exports = __webpack_public_path__ + "static/media/M1-10-Téfferos-Vallac-cod109.f1163048.png";